import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { formatDate } from "utils";
import { CODE_CHALLENGE_STATUS } from "constants/index";
import DataTable from "components/DataTable";
import Status from "components/Status";
import { PrimaryLink } from "components/Links";
import { CodeChallengeDetailsModal } from "components/CodeChallenges";
import Tags from "components/Tags";

/**
 * ApplicationChallenges
 *
 * @param {Array}   challenges
 * @param {Array}   missionRoleChallenges
 * @param {Boolean} loading
 */
const ApplicationChallenges = ({ challenges, missionRoleChallenges, loading, ...props }) => {
  const [challenge, setChallenge] = useState();

  return (
    <>
      <DataTable
        data={challenges}
        loading={loading}
        highlightedRowIds={missionRoleChallenges.map((challenge) => challenge.id)}
        emptyMessage={{
          title: "Missions.Applicants.ApplicationChallenges.LabelEmptyTitle",
          description: "Missions.Applicants.ApplicationChallenges.LabelEmptyDescription",
        }}
        columns={[
          {
            label: <FormattedMessage id="Missions.Applicants.ApplicationChallenges.LabelCompletedOn" />,
            cell: (row) => <div>{formatDate(row.completedAt, "MMM DD, YYYY")}</div>,
            width: "15%",
          },
          {
            label: <FormattedMessage id="Missions.Applicants.ApplicationChallenges.LabelType" />,
            cell: (row) => row?.challenge.types?.length > 0 && <Tags data={row.challenge.types} limit={3} />,
            width: "30%",
          },
          {
            label: <FormattedMessage id="Missions.Applicants.ApplicationChallenges.LabelName" />,
            cell: (row) => <div>{row.challenge.name}</div>,
            width: "20%",
          },
          {
            label: <FormattedMessage id="Missions.Applicants.ApplicationChallenges.LabelScore" />,
            cell: (row) => (
              <div>
                {row.score} / {row.maxScore}
              </div>
            ),
            width: "15%",
          },
          {
            label: <FormattedMessage id="Missions.Applicants.ApplicationChallenges.LabelPassed" />,
            cell: (row) => (
              <Status enabled={row.status == CODE_CHALLENGE_STATUS.passed}>
                <FormattedMessage id={`Global.${row.status == CODE_CHALLENGE_STATUS.passed ? "Yes" : "No"}`} />
              </Status>
            ),
            width: "15%",
          },
          {
            cell: (row) => (
              <PrimaryLink onClick={() => setChallenge(row)}>
                <FormattedMessage id="Global.ShowMore" />
              </PrimaryLink>
            ),
            width: "10%",
          },
        ]}
        {...props}
      />
      {challenge && (
        <CodeChallengeDetailsModal
          show={!!challenge}
          onClose={() => setChallenge(null)}
          challengeResponse={challenge}
        />
      )}
    </>
  );
};

ApplicationChallenges.propTypes = {
  challenges: PropTypes.array.isRequired,
  missionRoleChallenges: PropTypes.array,
  loading: PropTypes.bool,
};

export default ApplicationChallenges;
